import { AxisSwitcher, BorderGridContainer, GridBox, H2, PortableText, Section } from '@ahmdigital/ui';
import { isEmpty, map } from 'lodash/fp';

import { TopicGroup } from '../../../../../types/__codegen__/sanity/graphql';
import styles from './styles.module.sass';
import SummaryWithImageItem from './components/summary-with-image-item';

type SummariesProps = Pick<TopicGroup, 'topicGroup'> & {
  // TODO: [AP-1892] Fix code/type drift between sanity and components with fields like description/summary/slogan(Raw) etc…
  // GraphQL fragments alias sloganRaw→slogan and summaryRaw→summary (see topic-group-fields fragment)
  // So components receive 'slogan' and 'summary', not the codegen 'sloganRaw'/'summaryRaw' types
  slogan?: TopicGroup['sloganRaw'];
  summary?: TopicGroup['summaryRaw'];
};

const Summaries = ({ slogan, summary, topicGroup }: SummariesProps) => {
  if (isEmpty(topicGroup)) {
    return null;
  }

  const summaryWithImageItemPerRow = 1;

  return (
    <BorderGridContainer>
      <GridBox padding="1rem">
        <Section variant={['paddingTopSpacer1', 'paddingBottomSpacer1', styles.section]}>
          {slogan && (
            <H2 className={styles.slogan} variant="marginBottomSpacer8">
              <PortableText source={slogan} />
            </H2>
          )}
          {summary && <PortableText source={summary} variant={styles.summary} />}
          {/* @ts-expect-error - Automatic, Please fix when editing this file */}
          <AxisSwitcher key={topicGroup.id} space="0" limit={summaryWithImageItemPerRow} threshold="70rem">
            {/* @ts-expect-error - Automatic, Please fix when editing this file */}
            {map.convert({ cap: false })((summaryItem, index) => {
              const isEven = index % 2 === 1;
              return (
                <SummaryWithImageItem key={index} reverseColumn={isEven} refersToItemExplainedTerm={summaryItem} />
              );
            }, topicGroup)}
          </AxisSwitcher>
        </Section>
      </GridBox>
    </BorderGridContainer>
  );
};

export default Summaries;
